export const PLUGIN_NAME = 'region-resize-event';
